<template>
  <!-- // 收货地址展示 -->
  <div class="address_com">
    <div class="ticket_info_way_title ticket_icon shouhuo">
      <img :src="staticAssets.ImgObj.shouhuo_icon" alt />
      <span>{{TLang('收货地址','address')}}</span>
    </div>
    <div class="address_bottom">
      <div class="address_line_one">
        <div class="address_name">
          {{ receiveName }}
        </div>
        <div class="address_phone">
          {{ receiveMobile }}
        </div>
        <div class="address_id" v-if="receiveIdNo">
          {{ receiveIdNo && publicMethod.getExchangeCard(receiveIdNo) }}
        </div>
      </div>
      <div class="address_show">
        {{ receiveAddress }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "addressShow1",
  props: {
    receiveName: String,
    receiveMobile: String,
    receiveAddress: String,
    receiveIdNo: String
  },
  data() {
    return {};
  },
  created() {}
};
</script>

<style scoped lang="less">
.address_com {
  margin: 24px 0;
}
.ticket_icon {
  line-height: 21px;
}
.address_id {
  margin-left: 24px;
  float: left;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  // vertical-align: middle;
}
.ticket_icon span {
  display: inline-block;
  margin-left: 15px;
  font-size: 16px;
  color: #111111;
  line-height: 21px;
  height: 21px;
}
.address_bottom {
  margin-top: 22px;
  margin-left: 32px;
}
.address_line_one {
  height: 17px;
  line-height: 17px;
  font-size: 14px;
  .clearfix;
  color: #333333;
}
.address_name {
  float: left;
}
.address_phone {
  float: left;
  margin-left: 32px;
}
.address_show {
  margin-top: 17px;
  font-size: 14px;
  color: #666666;
  line-height: 17px;
}
</style>
